const Divider = ({
  color = 'border-gray-300',
  border = 'border-t',
  space = 'my-4'
}) => <div className={`${border} ${space} ${color}`}></div>;

export default Divider;
